<form [formGroup]="form">

	<div class="panel search-sidebar">

		<div class="row">
			<div class="col-3">
				<label for="bone-type">{{ labels().ARCHIVE_FILTERS_COMPONENT_BONE_TYPE }}</label>
				<div class="form-group">
					@for (bone of boneList; track $index) {
					<div class="custom-control custom-radio custom-control-inline w-50 me-0">
						<input type="radio" class="custom-control-input" [id]="'bone_' + bone" name="bone" formControlName="bone"
							[value]="bone" />
						<label class="custom-control-label" [for]="'bone_' + bone">{{ bone | boneTypeLabel }}</label>
					</div>
					}
				</div>
			</div>

			<div class="col-3">
				<label for="plan-type">{{ labels().ARCHIVE_FILTERS_COMPONENT_PLAN_TYPE }}</label>
				<div class="form-group">
					@for (planType of planTypeList; track $index) {
					<div class="custom-control custom-radio custom-control-inline w-50 me-0">
						<input type="radio" class="custom-control-input" [id]="'planType_' + planType" name="planType"
							formControlName="planType" [value]="planType" />
						<label class="custom-control-label" [for]="'planType_' + planType">
							{{ planType | planTypeLabel }}
						</label>
					</div>
					}
				</div>
			</div>
		</div>

		<div class="row mt-5">
			<div class="col">
				<button type="button" class="btn btn-secondary-outline me-5" (click)="clear()">
					{{ labels().ARCHIVE_FILTERS_COMPONENT_BTN_CLEAR }}
				</button>
				<button type="button" class="btn btn-primary" (click)="search()">
					{{ labels().ARCHIVE_FILTERS_COMPONENT_BTN_SEARCH }}
				</button>
			</div>
		</div>

	</div>

</form>